import { type FC, useState } from 'react';
import { Form } from 'react-bootstrap';

import CodeMirrorHTML from '@editor2/components/CodeMirrorHTML';
import { useDebouncedDispatch } from '@editor2/hooks/useDebouncedDispatch';
import { type Carousel } from '@editor2/types/pageElements';
import { updateElement } from '@editor2/reducers/editor/editorSlice';

import { figurePropertiesBlock } from '../TimelineElement/styles';

interface Props {
	element: Carousel;
	courseId: number;
}

const FigureProperties: FC<Props> = (props) => {
	const { element, courseId } = props;
	const { figure_number, title, caption, credits } = element;

	const commonPayload = { elementId: element.family_id, courseId };
	const debouncedDispatch = useDebouncedDispatch();

	const [figureProperties, setFigureProperties] = useState({
		figure_number,
		title,
		caption,
		credits
	});

	const handleChange = (value) => {
		setFigureProperties({ ...figureProperties, ...value });
		debouncedDispatch(updateElement({ ...commonPayload, ...value }));
	};

	return (
		<div className={figurePropertiesBlock}>
			<div className="block">
				<Form.Group className="figure-number">
					<Form.Label>Number</Form.Label>
					<Form.Control
						value={figureProperties.figure_number}
						placeholder="Figure number"
						onChange={(e) => handleChange({ figure_number: e.target.value })}
					/>
				</Form.Group>

				<Form.Group className="figure-title">
					<Form.Label>Title</Form.Label>
					<Form.Control
						value={figureProperties.title}
						placeholder="Figure title"
						onChange={(e) => handleChange({ title: e.target.value })}
					/>
				</Form.Group>
			</div>

			<Form.Group>
				<Form.Label>Caption</Form.Label>
				<CodeMirrorHTML
					value={figureProperties.caption}
					showTips={false}
					options={{ placeholder: 'Figure caption' }}
					onChange={(value) => handleChange({ caption: value })}
				/>
			</Form.Group>

			<Form.Group>
				<Form.Label>Credit(s)</Form.Label>
				<CodeMirrorHTML
					value={figureProperties.credits}
					showTips={false}
					options={{ placeholder: 'Figure credits' }}
					onChange={(value) => handleChange({ credits: value })}
				/>
			</Form.Group>
		</div>
	);
};

export default FigureProperties;
